<template>
    <VChart class="chart" v-bind:style="{ height: state.height, width: state.width }" :option="state.selectOption" />
</template>

<script lang="ts" config>
import { reactive, watch } from "@/BaseComponent";

import { TitleComponent, TooltipComponent, LegendComponent, ToolboxComponent, GridComponent } from "echarts/components";

import { setOption } from "@/services/commonChartUtils";
import VChart from "vue-echarts";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart, BarChart, PieChart, CandlestickChart } from "echarts/charts";
import { use } from "echarts/core";

export default {
    props: [
        "title",
        "subTitle",
        "titlePadding",
        "data",
        "legendPosition",
        "legendContent",
        "valueContent",
        "width",
        "height",
    ],

    components: {
        VChart,
    },

    setup(props: any) {
        const state = reactive({
            selectOption: setOption(props),
            height: props.height,
            width: props.width,
        });
        watch(props, () => {
            state.selectOption = setOption(props);
        });
        use([
            TitleComponent,
            TooltipComponent,
            LegendComponent,
            ToolboxComponent,
            GridComponent,
            CanvasRenderer,
            LineChart,
            BarChart,
            PieChart,
            CandlestickChart,
        ]);
        return {
            state,
        };
    },
};
</script>
<style scoped>
.chart {
    max-width: 100%;
    min-width: 50%;
    height: 400px;
    width: 100%;
}
</style>
